import React from "react"
import { IUserDocument, ELoggedInUserType } from "../../../../models"
import strings from "../../../../localization/strings"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui"
import { browserHistory } from "react-router"
import * as utils from "../../../../helpers/utils"
interface IProps {
  user: IUserDocument
  loggedInUserType: ELoggedInUserType
  height: number
}

const AccrualsDashboard: React.SFC<IProps> = (props: IProps) => {
  const tableHeaderHeight = 30
  const tableBodyRowHeight = 25
  const hasVScrollBar = props.height - tableHeaderHeight - props.user.Accruals.length * tableBodyRowHeight < 0
  return (
    <div style={{ height: props.height, marginTop: -7, marginLeft: 5 }}>
      <Table
        height={`${props.height - tableHeaderHeight}px`}
        fixedHeader
        selectable={false}
        multiSelectable={false}
        onCellClick={() => browserHistory.push(props.loggedInUserType === ELoggedInUserType.Employee ? `/es/accruals` : `/user-details/${props.user.Id}/accruals`)}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          enableSelectAll={false}
        >
          <TableRow style={{ height: tableHeaderHeight }}>
            <TableHeaderColumn style={{ padding: "0px 0px 0px 10px", height: tableHeaderHeight, cursor: "pointer" }}>{strings.Accrual}</TableHeaderColumn>
            <TableHeaderColumn style={{ padding: 0, height: tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 65 }}>{strings.Beginning}</TableHeaderColumn>
            <TableHeaderColumn style={{ padding: 0, height: tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 80 }}>{strings.Pending}</TableHeaderColumn>
            <TableHeaderColumn style={{ paddingLeft: 0, paddingTop: 0, paddingBottom: 0, paddingRight: hasVScrollBar ? 27 : 10, height: tableHeaderHeight, textAlign: "right", cursor: "pointer", width: 125 }}>{strings.Pending_Balance}</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          deselectOnClickaway={false}
          showRowHover={false}
          stripedRows={false}
        >
          {props.user.Accruals.filter(item => !item.Deleted && item.AllowUseForLeaveTracking && item.Active).map((row, index) =>
           <TableRow key={index} style={{ height: tableBodyRowHeight, borderBottom: "none" }} >
              <TableRowColumn style={{ padding: "0px 0px 0px 10px", height: tableBodyRowHeight, cursor: "pointer" }}><span title={row.Name}>{row.Name}</span></TableRowColumn>
              <TableRowColumn style={{ padding: 0, height: tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 65 }}>{utils.roundToTwo(row.Balance).toString()}</TableRowColumn>
              <TableRowColumn style={{ padding: 0, height: tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 80 }}>{utils.roundToTwo(row.Balance - row.PendingBalance).toString()}</TableRowColumn>
              <TableRowColumn style={{ padding: "0px 10px 0px 0px", height: tableBodyRowHeight, cursor: "pointer", textAlign: "right", width: 125 }}>{utils.roundToTwo(row.PendingBalance).toString()}</TableRowColumn>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export default AccrualsDashboard
